var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwoDDrawing = function SvgTwoDDrawing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.975 9.244c0-.25.205-.444.444-.444h8.106V.682c0-.239.205-.444.444-.444.25 0 .444.205.444.444V8.8h8.118c.239 0 .444.193.444.444 0 .24-.205.444-.444.444h-8.118v8.106a.445.445 0 0 1-.444.444.45.45 0 0 1-.444-.444V9.688H1.419a.45.45 0 0 1-.444-.444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.563 14.488c-1.258 0-1.93-.666-1.93-1.912V5.659c0-1.246.672-1.913 1.93-1.913h6.876c1.264 0 1.93.667 1.93 1.913v6.917c0 1.246-.666 1.912-1.93 1.912zm.108-1.269h6.666c.49 0 .768-.25.768-.774v-6.65c0-.523-.279-.78-.768-.78H6.67c-.501 0-.769.257-.769.78v6.65c0 .524.268.774.769.774"
  })));
};
export default SvgTwoDDrawing;